import styled, { css } from 'styled-components'

import { Input, type InputProps } from '@root/shared/ui-kit'

import type { Intent } from '@root/shared/ui-kit'

export type AuthInputProps = InputProps & {
  intent?: Intent
}

export const AuthInput: React.FC<AuthInputProps> = ({
  children,
  intent = 'neutral',
  ...props
}) => {
  return (
    <Root
      {...props}
      autoCorrect="off"
      autoFocus
      spellCheck={false}
      autoCapitalize="off"
      size="m"
      $intent={intent}
    >
      {children}
    </Root>
  )
}

const Root = styled(Input)<{ $intent: Intent }>`
  --input-background: var(--appearanceA-2);

  &:focus-within {
    --input-background-active: var(--appearanceA-5);
  }

  ${({ $intent }) => {
    switch ($intent) {
      case 'error': {
        return css`
          border-radius: 10px;
          box-shadow: inset 0 0 0 1px rgba(var(--error-9-rgb), 0.7);
        `
      }
      case 'success': {
        return css`
          border-radius: 10px;
          box-shadow: inset 0 0 0 1px rgba(var(--success-9-rgb), 0.7);
        `
      }
    }
  }}
`
